import { useCallback } from 'react'
import mParticleSdk, { EventType, SDKEventCustomFlags, SDKEventOptions } from '@mparticle/web-sdk'

import useConfig from '../../config/state/use-config'
import useOrder from '../../order/state/order/use-order'

import { useInternalAnalytics } from '../../../utils/internalAnalytics'
import { useMParticleEventProperties } from './useMParticleEventProperties'

import { makeMParticleGlobalProperties } from '../../../utils/internalAnalytics/internalAnalyticsUtils'

type TrackPurchaseEventFn = (
  transactionId: number,
  customAttributes?: mParticleSdk.SDKEventAttrs,
  customFlags?: SDKEventCustomFlags,
) => void

function useTrackPurchseEvent(): TrackPurchaseEventFn {
  const config = useConfig()
  const order = useOrder()
  const mParticleEventProperties = useMParticleEventProperties()

  const { mParticle, consentSynced } = useInternalAnalytics()

  return useCallback(
    (transactionId, customAttributes, customFlags) => {
      if (!mParticle || !consentSynced) {
        return
      }

      // "Donation", campaign_id, amount, 1, undefined, "other", undefined, undefined, undefined
      const product = mParticle.eCommerce.createProduct(
        'Donation',
        config.campaignId,
        order.amount.value,
        1,
        undefined,
        'other',
        undefined,
        undefined,
        undefined,
      )

      const customAttributesWithCommonProperties: mParticleSdk.SDKEventAttrs = {
        ...makeMParticleGlobalProperties(mParticle),

        ...customAttributes,

        npo_id: mParticleEventProperties.npo_id,
        npo_name: mParticleEventProperties.npo_name,
        campaign_id: mParticleEventProperties.campaign_id,

        ...mParticleEventProperties.donation_components,
        ...mParticleEventProperties.donation_selections,

        Fees: order.dcf.value.fee,
      }

      const customFlagsWithCommonFlags = {
        ...customFlags,

        'GA4.Title': document.title,
        'GA4.Location': document.location.href,
        'GA4.Referrer': document.referrer,
      }

      const customTransactionAttributes: mParticleSdk.TransactionAttributes = {
        Id: transactionId,
        Revenue: order.amount.value,
        Tax: 0,
      }

      mParticle.eCommerce.logProductAction(
        mParticleSdk.ProductActionType.Purchase,
        [product],
        customAttributesWithCommonProperties,
        customFlagsWithCommonFlags,
        customTransactionAttributes,
      )
    },
    [
      mParticle,
      consentSynced,
      mParticleEventProperties,
      config.campaignId,
      order.amount.value,
      order.dcf.value.fee,
    ],
  )
}

export default useTrackPurchseEvent
